import { render, staticRenderFns } from "./SampleRegister.vue?vue&type=template&id=13300b0f"
import script from "./SampleRegister.vue?vue&type=script&lang=js"
export * from "./SampleRegister.vue?vue&type=script&lang=js"
import style0 from "./SampleRegister.vue?vue&type=style&index=0&id=13300b0f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports